import * as React from 'react';
import {
  DialogTitle, DialogContent, DialogActions, Typography,
} from '@mui/material';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { deleteVolunteer, getVolunteers } from '../../../store/actions/actions';
import { DialogActionButtons } from '../../dialogActionButtons/DialogActionButtons';
import { BootstrapDialog, dialogStyles, useStyles } from './modalReject.styles';
import { IProps } from './types';

export const ModalReject = ({ open, setOpen, volunteerId }: IProps): JSX.Element => {
  const searchString = new URLSearchParams(window.location.search);
  const id = searchString.get('id');
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleSubmit = () => {
    deleteVolunteer(id, volunteerId || '')(dispatch);
    getVolunteers(id)(dispatch);
    handleClose();
  };

  const actionProps = {
    cancel: 'CANCEL',
    submit: 'YES, REJECT VOLUNTEER',
    handleClose,
    handleSubmit,
  };

  return (
    <div>
      <BootstrapDialog
        className={classes.modal}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={dialogStyles}
          className={classes.modalMainTitle}
        >
          Reject volunteer
        </DialogTitle>
        <DialogContent>
          <div>
            <Typography
              gutterBottom
              className={classes.modalTitle}
            >
              Are you sure you want to reject this volunteer?
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <DialogActionButtons {...actionProps} />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};
